import { logger as LOG } from '@garnish/logger';

// ─── Logger ──────────────────────────────────────────────────────────────────

export const logger = LOG.extend('ID.ME STATE MACHINE');
